export const ERRORS = {
	COMPONENT_CONTAINER_NO_DEFAULT_VALUE: (
		type: string,
		key: string,
		schema: string,
	) => `[ WARNING ]
The \`${type}\` with \`key: ${key}\` has no default value in the \`${schema}\` schema.
The \`autotypes.d.ts\` file will be generated with incomplete information.
Please check the schema and add a default value for this field.
`,
	FIELD_NOT_IMPLEMENTED: (type: string) => `[ WARNING ]
The field \`${type}\` has not been implemented yet.
Please check the schema and make sure the field name is correct.
`,
};
